import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import type { VoltaxVideoBlockInterface } from '~/types/AppData/PageBuilder/VoltaxVideoBlockInterface';
import VideoPlayerEmbed from '~/components/Shared/Video/VideoPlayerEmbed';

export default component$<VoltaxVideoBlockInterface['props']>(
  ({ metadata, oEmbed }): JSX.Element => {
    if (oEmbed?.html) {
      return <VideoPlayerEmbed html={oEmbed.html} version={oEmbed.version} />;
    }

    if (!metadata) return null;

    const { contentId, orgId = '', subId = '' } = metadata;

    if (!contentId) return null;

    return (
      <div class='relative overflow-hidden pt-[59.25%]'>
        <iframe
          class='absolute border-none left-0 top-0'
          src={`https://vms-players.minutemediaservices.com/voltax_player_embed.html?contentId=${contentId}&orgId=${orgId}&subId=${subId}`}
          width='100%'
          height='100%'
          allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
          allowFullscreen={true}
        />
      </div>
    );
  }
);
